$( document ).ready(function() {
    function updateConsent(consent) {
        if(typeof gtagOld === 'function') {
            gtagOld("consent", "update", consent);
        }
        if(typeof oaiq === 'function') {
            const ad_consent = consent['ad_storage'] === 'granted' && consent['ad_user_data'] === 'granted' && consent['ad_personalization'] === 'granted';
            oaiq("consent", ad_consent);
        }
    }

    $('.component-Exports-CookiesBar button[value="accept"]').click(function() {
        const consent = {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
        };
        updateConsent(consent);
    });
    $('.component-Exports-CookiesBar button[value="refuse"]').click(function() {
        const consent = {
            'ad_storage': 'denied',
            'analytics_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
        };
        updateConsent(consent);
    });
    $('.component-Exports-CookiesBar button[value="save"]').click(function() {
        const ad_storage = $('.component-Exports-CookiesBar input[name="marketing"]').is(':checked') ? 'granted' : 'denied';
        const analytics_storage = $('.component-Exports-CookiesBar input[name="analytics"]').is(':checked') ? 'granted' : 'denied';
        const ad_user_data = $('.component-Exports-CookiesBar input[name="user"]').is(':checked') ? 'granted' : 'denied';
        const ad_personalization = $('.component-Exports-CookiesBar input[name="user"]').is(':checked') ? 'granted' : 'denied';

        const consent = {
            'ad_storage': ad_storage,
            'analytics_storage': analytics_storage,
            'ad_user_data': ad_user_data,
            'ad_personalization': ad_personalization,
        };
        updateConsent(consent);
    });

});